import {z} from '@hono/zod-openapi';

import {jsonValueSchema} from './AdvertisementPayloadSchema';

export const AutoplacPlFeedResponseSchema = z
  .array(z.record(jsonValueSchema).openapi({type: 'object', additionalProperties: true}))
  .openapi('AutoplacPlFeedResponse', {
    example: [{id: '22222222-2222-4222-8222-222222222222', title: 'Bentley Continental GT'}],
  });

export type AutoplacPlFeedResponse = z.infer<typeof AutoplacPlFeedResponseSchema>;
